// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import * as React from 'react'
import { Map } from 'mapbox-gl'
import { ReactComponent as PlusSvg } from 'assets/images/map-controller/plus.svg'
import { ReactComponent as MinusSvg } from 'assets/images/map-controller/minus.svg'
import Icon from '@ant-design/icons'

const Plus = props => <Icon component={PlusSvg} {...props} />
const Minus = props => <Icon component={MinusSvg} {...props} />

export interface Props {
  zoomDiff?: number
  map: Map
  onClick?: (map: Map, zoomDiff: number) => void
}

export interface State {
  disablePlus: boolean
  disableMinus: boolean
}

export class ZoomControl extends React.Component<Props, State> {
  public static defaultProps = {
    zoomDiff: 0.5,
    onClick: (map: Map, zoomDiff: number) => {
      map.zoomTo(map.getZoom() + zoomDiff)
    }
  }

  public state = {
    disablePlus: false,
    disableMinus: false
  }

  private prevZoom: number = null

  componentDidMount () {
    this.updateButtonDisableState()
    this.prevZoom = this.props.map.getZoom()
  }

  componentDidUpdate () {
    if (this.prevZoom !== this.props.map.getZoom()) {
      this.prevZoom = this.props.map.getZoom()
      this.updateButtonDisableState()
    }
  }

  private updateButtonDisableState () {
    const { map } = this.props
    let { disablePlus, disableMinus } = this.state
    if (map.getZoom() >= map.getMaxZoom()) {
      disablePlus = true
    } else if (map.getZoom() <= map.getMinZoom()) {
      disableMinus = true
    } else {
      disablePlus = false
      disableMinus = false
    }
    this.setState({
      disablePlus,
      disableMinus
    })
  }

  private onClickPlus = () => {
    this.props.onClick!(this.props.map, this.props.zoomDiff!)
    const { map, zoomDiff } = this.props
    this.prevZoom = Math.round(map.getZoom() * 1e2) / 1e2 + zoomDiff
  }

  private onClickMinus = () => {
    this.props.onClick!(this.props.map, -this.props.zoomDiff!)
    const { map, zoomDiff } = this.props
    this.prevZoom = Math.round(map.getZoom() * 1e2) / 1e2 + zoomDiff
  }

  public render () {
    const { disableMinus, disablePlus } = this.state
    const plusButtonProps: any = {}
    const minusButtonProps: any = {}
    if (disableMinus) {
      minusButtonProps.disabled = true
    }
    if (disablePlus) {
      plusButtonProps.disabled = true
    }

    return (
      <>
        <button onClick={this.onClickPlus} {...plusButtonProps}>
          <Plus />
        </button>
        <button onClick={this.onClickMinus} {...minusButtonProps}>
          <Minus />
        </button>
      </>
    )
  }
}
